








































































































































































































import axios from 'axios';
import {Vue, Component, Ref} from "vue-property-decorator";
import {LoadEvents} from "@/components/LoadEvents";

type Segment = {
  id: string,
  name: string,
}

type AudienceUser = {
  user_id: string,
}

type AudienceResponse = {
  audience: Array<AudienceUser>
}

type Log = {
  ip: string
  pixel_id: string
  time: string
  data: any
  browser: string
  device: string
  os: string
  city: string
  country: string
  time_zone: string
  latitude: number
  longitude: number
}

type Event = {
  id: string
  domain: string
}

type AudienceUserResponse = {
  ips: Array<string>
  user_ids: Array<string>
  segments: Array<Segment>
  categories: Array<Segment>
  events: Array<Event>
  logs: Array<Log>
  personal_data: Array<any>
  google_user_id: string
}

type SitesResponse = {
  sites: Array<Site>
}

type Site = {
  id: string,
  domain: string,
  event_id: string,
}

@Component({})
export default class Audience extends Vue {
  @Ref('menu') VMenu!: any;
  private date: Array<string> = [];
  private menu: boolean = false;
  private user_dialog: boolean = false;
  private user_id: string = '';
  private google_user_id: string = '';
  private event_id: string = '';
  private segment_id: string = '';
  private personal: boolean = false;
  private find_user_dialog: boolean = false;
  private sites: Array<any> = [];
  private segments: Array<any> = [];
  private from!: Date;
  private to: Date = new Date();
  private personal_data_query = '';

  private user_ips: Array<string> = ['192.168.1.0', '10.244.0.1'];
  private user_ids: Array<string> = [];

  private user_segments: Array<string> = ['seg1', 'seg2'];
  private user_categories: Array<string> = ['cat1', 'cat2'];
  private user_sites: Array<string> = ['site1.com', 'site2.com'];

  private user_personal_data: any = {
    headers: [
      {
        text: "Data",
        value: "data"
      },
    ],
    data: [] as Array<any>,
    loading: true,
  }

  private user_log: any = {
    headers: [
      {
        text: "User ID",
        value: "user_id"
      },
      {
        text: "Event",
        value: "pixel_id"
      },
      {
        text: "Time",
        value: "time"
      },
      {
        text: "IP",
        value: "ip"
      },
      {
        text: "Country",
        value: "country",
      },
      {
        text: "City",
        value: "city",
      },
      {
        text: "TZ",
        value: "time_zone",
      },
      {
        text: "Latitude",
        value: "latitude",
      },
      {
        text: "Longitude",
        value: "longitude",
      },
      {
        text: "Event",
        value: "data.event"
      },
      {
        text: "User-Agent",
        value: "user_agent"
      },
      {
        text: "Browser",
        value: "browser",
      },
      {
        text: "Device",
        value: "device",
      },
      {
        text: "OS",
        value: "os",
      },
      {
        text: "Data",
        value: "data",
        class: 'line-wrap'
      },
    ],
    loading: true,
    all_data: [] as Array<Log>,
    all_logs: false,

    get data(): Array<Log> {
      if (this.all_logs) return this.all_data
      return this.all_data.filter((el: Log) =>
          Object.keys(el.data).length > 0)
    }
  }


  private users: any = {
    headers: [
      {
        text: "User ID",
        value: "user_id"
      },
      {
        text: "Last activity time",
        value: "last_activity_time"
      },
      {
        text: "Actions",
        value: "actions",
        align: 'end',
        sortable: false,
      }
    ],
    data: [] as Array<AudienceUser>,
    page: 1,
    loading: true,
  }


  mounted() {
    this.from = new Date(this.to.getTime() - 24 * 60 * 60 * 1000)
    this.date = [
      this.from.toISOString().split('T')[0],
      this.to.toISOString().split('T')[0]]
    this.$store.dispatch('set_title', 'Audience')
    this.loadUsers('', '', false, '')

    let structThis = this
    LoadEvents(function (es: Array<any>) {
      structThis.sites = es
    })

    this.loadSegments()
    // axios
    //     .get<SitesResponse>('/api/v1/sites')
    //     .then(response => {
    //         this.sites = response.data.sites || []
    //     })
  }

  loadSegments() {
    axios
        .get<Array<Segment>>('/api/v1/segments')
        .then(response => this.segments = response.data || [])
  }

  eventName(id: string): string {
    let e = this.sites.find(s => s.id == id)
    if (e) {
      return e.name
    }
    return id
  }

  loadUsers(eventID: string, segmentID: string, personal: boolean, query: string) {
    this.users.loading = true
    let params: any = {
      from: this.from.toISOString(),
      to: this.to.toISOString(),
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    if (eventID != '') {
      params.event_id = eventID
    }
    if (segmentID != '') {
      params.segment_id = segmentID
    }
    if (personal) {
      params.personal = true
    }
    if (query) {
      params.query = query
    }
    axios
        .get<AudienceResponse>('/api/v1/audience', {
          params: params
        })
        .then(response => {
          console.log(response.data)
          this.users.data = response.data.audience || []
          this.users.loading = false
          console.log("setting page")
          this.users.page = 1
        })
  }

  onChange() {
    if (this.personal_data_query != '') {
      this.personal = true
    }
    this.loadUsers(this.event_id, this.segment_id, this.personal, this.personal_data_query)
  }

  findUser() {
    this.find_user_dialog = false
    this.showAudienceUser(this.user_id)
  }

  showAudienceUser(user_id: string) {
    this.user_id = user_id
    this.user_dialog = true
    console.log(user_id)

    axios
        .get<AudienceUserResponse>('/api/v1/audience/user/' + user_id)
        .then(response => {
          this.user_ips = response.data.ips
          this.user_ids = response.data.user_ids
          this.user_segments = []
          this.user_categories = []
          this.user_sites = []
          response.data.segments = response.data.segments || []
          response.data.categories = response.data.categories || []
          response.data.events = response.data.events || []
          response.data.logs = response.data.logs || []
          response.data.segments.forEach(seg => this.user_segments.push(seg.name))
          response.data.categories.forEach(seg => this.user_categories.push(seg.name))

          response.data.events.forEach(ev => {
            let s = this.sites.find(s => s.id == ev)
            if (s) {
              this.user_sites.push(s.name)
            }
          })

          this.user_personal_data.data = response.data.personal_data || []
          this.user_log.all_data = response.data.logs
          // this.user_log.data = response.data.logs.filter(el =>
          //     Object.keys(el.data).length >0 )
          // 7cdf5e57-b2a7-4aa6-af56-a0f65f79a279
          this.user_log.loading = false
          this.google_user_id = response.data.google_user_id || ''
          this.user_personal_data.loading = false
        })
  }

  saveDate(date: Array<Date>) {
    console.log(date)
    this.VMenu.save(date)
    let df = new Date(date[0] + " ")
    let dt = new Date(date[1] + " ")
    this.from = df
    this.to = dt
    this.onChange()
  }

  closeDialog() {
    this.user_dialog = false
  }
}
